// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_zsqbm > * {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.container_zsqbm > input {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/CompositeTextInput.css"],"names":[],"mappings":"AAAA;EACE,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd","sourcesContent":[".container > * {\n  flex-shrink: 0;\n}\n\n.container > input {\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_zsqbm`
};
export default ___CSS_LOADER_EXPORT___;
